const Elearning = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/Index.vue')
const Setting = () => import(/* webpackChunkName: "setting" */ '@/views/private/kelas/setting/Index.vue')
const Category = () => import(/* webpackChunkName: "settingelearning" */ '@/components/kelas/setting/Elearning.vue')
const Type = () => import(/* webpackChunkName: "settingelearning" */ '@/components/kelas/setting/Type.vue')
const Promo = () => import(/* webpackChunkName: "settingelearning" */ '@/components/kelas/setting/Promo.vue')
const Banner = () => import(/* webpackChunkName: "settingelearning" */ '@/components/kelas/setting/Banner.vue')
const Agenda = () => import(/* webpackChunkName: "settingelearning" */ '@/components/kelas/setting/Agenda.vue')
const Panduan = () => import(/* webpackChunkName: "settingelearning" */ '@/components/kelas/setting/Panduan.vue')
const DetailStream = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/detail/Stream.vue')
const DetailElearning = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/detail/Elearning.vue')
const ReportMember = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/report/member/Index.vue')
const ReportTransaksi = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/report/transaction/Index.vue')
const ReportTransaksiElearning = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/report/transaction/elerning/Index.vue')
const ReportTransaksiStream = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/report/transaction/steram/Index.vue')
const ReportMonthElearning = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/report/month/elerning/Index.vue')
const ReportMonthStream = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/report/month/steram/Index.vue')
const RefundTransaksi = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/refund/Index.vue')
const Member = () => import(/* webpackChunkName: "elearning" */ '@/views/private/kelas/member/Index.vue')


const routes = [
  {
    path: "/kelas",
    name: "elearning",
    component: Elearning,
    meta: {
      title: "Kelas Online"
    }
  },
  {
    path: "/kelas/dashboard",
    name: "kelasDashboard",
    component: () => import(/* webpackChunkName: "kelasDashboard" */ '@/views/private/kelas/Dashboard.vue'),
    meta: {
      title: "Dashboard Kelas Online"
    }
  },
  {
    path: "/setting",
    name: "setting",
    component: Setting,
    meta: {
      title: "Pengaturan"
    },
    children: [
      {
        path: '/kelas/setting/caregory',
        name: 'setting kategori',
        component: Category,
        meta: {
          title: "Pengaturan Kategori Kelas"
        }
      },
      {
        path: '/kelas/setting/type',
        name: 'setting type',
        component: Type,
        meta: {
          title: "Pengaturan Tipe Kelas"
        }
      },
      {
        path: '/kelas/setting/promo',
        name: 'setting promo',
        component: Promo,
        meta: {
          title: "Pengaturan Promo Kelas"
        }
      },
      {
        path: '/kelas/setting/banner',
        name: 'setting banner',
        component: Banner,
        meta: {
          title: "Pengaturan Banner Kelas"
        }
      },
      {
        path: '/kelas/setting/agenda',
        name: 'setting agenda',
        component: Agenda,
        meta: {
          title: "Pengaturan Agenda Kelas"
        }
      },
      {
        path: '/kelas/setting/panduan',
        name: 'setting panduan',
        component: Panduan,
        meta: {
          title: "Pengaturan Panduan Kelas"
        }
      }
    ]
  },
  {
    path: "/kelas/stream/:id",
    name: "elearning stream",
    component: DetailStream,
    meta: {
      title: "Detail Zoom Class"
    }
  },
  {
    path: "/kelas/elearning/:id",
    name: "elearning elearning",
    component: DetailElearning,
    meta: {
      title: "Detail Elearning"
    }
  },
  {
    path: "/kelas/report/member",
    name: "elearning report member",
    component: ReportMember,
    meta: {
      title: "Laporan Peserta"
    }
  },
  {
    path: "/kelas/report/transaction",
    name: "elearning report transaksi",
    component: ReportTransaksi,
    meta: {
      title: "Laporan Transaksi"
    }
  },
  {
    path: "/kelas/report/transaction/elearning",
    name: "elearning report transaksi kelas",
    component: ReportTransaksiElearning,
    meta: {
      title: "Laporan Transaksi Kelas Elearning"
    }
  },
  {
    path: "/kelas/report/transaction/stream",
    name: "elearning report transaksi stream",
    component: ReportTransaksiStream,
    meta: {
      title: "Laporan Transaksi Zoom Class"
    }
  },
  {
    path: "/kelas/report/transaction/month/stream",
    name: "elearning report transaksi month stream",
    component: ReportMonthStream,
    meta: {
      title: "Laporan Transaksi Perbulan Zoom Class"
    }
  },
  {
    path: "/kelas/report/transaction/month/elearning",
    name: "elearning report transaksi month elearning",
    component: ReportMonthElearning,
    meta: {
      title: "Laporan Transaksi Perbulan Kelas Elearning"
    }
  },
  // {
  //   path: "/kelas/report/transaction/category",
  //   name: "elearning report transaksi category",
  //   component: ReportCategory,
  //   meta: {
  //     title: "Laporan Transaksi By Kategori"
  //   }
  // },
  {
    path: "/kelas/refund",
    name: "elearning refund",
    component: RefundTransaksi,
    meta: {
      title: "Refund Transaksi"
    }
  },
  {
    path: "/kelas/member",
    name: "elearning member",
    component: Member,
    meta: {
      title: "Peserta"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})